import { DELETE, GET, PATCH, POST } from '../../common/common.service'
import endpointsBillables from './enpoints'

const BillablesService = {
  getAll: async ({ filter, sort, limit, skip }) =>
    GET(endpointsBillables.LOAD(filter, sort, limit, skip)),
  getById: async (id) => GET(endpointsBillables.LOAD_BY_ID(id)),
  create: async (body) => POST(endpointsBillables.CREATE, body),
  update: async ({ _id, body }) =>
    PATCH(endpointsBillables.LOAD_BY_ID(_id), body),
  remove: async (id) => DELETE(endpointsBillables.LOAD_BY_ID(id)),
}

export default BillablesService
